/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import React from 'react';
import { Button } from 'react-bootstrap';
import { getUTCTimeStampMMDDYYYY } from '../../../../../../SharedModules/DateUtilities/DateUtilities';
import SVGComponent from '../../../../../../SharedModules/SVGComponents/SVGComponents';
import { NDCDetailsTextFieldComponent } from '../../../../../Display/NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';
import { PaperComponent } from '../../../../../../SharedModules/utilities/utilities';

const DeleteCheckLogPopup = ({
  open = false,
  onConfirmClick = () => {},
  handleClose = () => {},
  data = {},
}) => {
  return (
    <Dialog
      open={open}
      className="multiGroupDialog custom-dialog-box"
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <div style={{ cursor: 'move' }} id="draggable-dialog-title">
        <DialogContent>
          <div className="custom-panel">
            <div className="panel-header">
              <span className="float-left"> Request Delete Check Log </span>
              <span className="float-right" role="button" onClick={handleClose}>
                <i className="fa fa-times-circle" aria-hidden="true" />
              </span>
              <div className="clearfix" />
            </div>
            <div className="row mt-3" style={{ margin: '0' }}>
              <div className="col-3 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Check Info"
                  value={(data && data.checkInfo) || ''}
                  className="ml-0 mb-0"
                  onChange={(e) => {}}
                />
              </div>
              <div className="col-3 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Check Log Number"
                  value={(data && data.checkLogNum) || ''}
                  className="ml-0 mb-0"
                  onChange={(e) => {}}
                />
              </div>
              <div className="col-3 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Current Suspended Date"
                  value={
                    (data &&
                      data.suspendedDt &&
                      getUTCTimeStampMMDDYYYY(data.suspendedDt)) ||
                    ''
                  }
                  className="ml-0 mb-0"
                  onChange={(e) => {}}
                />
              </div>
              <div className="col-3 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Batch Date"
                  value={
                    (data &&
                      data.batchDt &&
                      getUTCTimeStampMMDDYYYY(data.batchDt)) ||
                    ''
                  }
                  className="ml-0 mb-0"
                  onChange={(e) => {}}
                />
              </div>
              <div className="col-4 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Batch Number"
                  value={(data && data.batchNum) || ''}
                  className="ml-0 mb-0"
                  onChange={(e) => {}}
                />
              </div>
              <div className="col-4 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Check Number"
                  value={(data && data.checkNum) || ''}
                  className="ml-0 mb-0"
                  onChange={(e) => {}}
                />
              </div>
              <div className="col-4 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Check Date"
                  value={
                    (data &&
                      data.checkDt &&
                      getUTCTimeStampMMDDYYYY(data.checkDt)) ||
                    ''
                  }
                  className="ml-0 mb-0"
                  onChange={(e) => {}}
                />
              </div>
              <div className="col-4 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Check Amount"
                  value={(data && data.checkAmt) || ''}
                  className="ml-0 mb-0"
                  onChange={(e) => {}}
                />
              </div>
              <div className="col-4 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Check Issuer"
                  value={(data && data.checkIssuer) || ''}
                  className="ml-0 mb-0"
                  onChange={(e) => {}}
                />
              </div>
              <div className="col-4 mb-2">
                <NDCDetailsTextFieldComponent
                  label="Check Identifier"
                  value={(data && data.checkIdentifier) || ''}
                  className="ml-0 mb-0"
                  onChange={(e) => {}}
                />
              </div>
            </div>
          </div>
        </DialogContent>

        <DialogActions>
          <div className="btn-wrapper my-3 justify-content-end">
            <Button
              onClick={onConfirmClick}
              data-testid="masterDataSave"
              className="btn btn-success btn-search mr-2"
            >
              <SVGComponent iconName="Icon_awesome-check-circle" />
              OK
            </Button>
            <Button
              onClick={handleClose}
              className="btn btn-cancel btn-primary mr-2"
              color="primary"
              autoFocus
            >
              <SVGComponent iconName="Icon-cancel" />
              Cancel
            </Button>
          </div>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default DeleteCheckLogPopup;
